/**
 * Toggle Portion Info Popup
 * @param {Event} event 
 */
function togglePortionInfo(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const backdrop = document.getElementById('portionInfoBackdrop');
  const popover = document.getElementById('portionInfoPopover');

  if (!backdrop || !popover) return;

  const isActive = backdrop.classList.contains('is-active');

  if (isActive) {
    backdrop.classList.remove('is-active');
    popover.classList.remove('is-active');
    document.body.style.overflow = '';
  } else {
    backdrop.classList.add('is-active');
    popover.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }
}

// Close on Escape key
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const backdrop = document.getElementById('portionInfoBackdrop');
    if (backdrop && backdrop.classList.contains('is-active')) {
      togglePortionInfo();
    }
  }
});
